import { render, staticRenderFns } from "./upLook.vue?vue&type=template&id=1b405c5a&scoped=true"
import script from "./upLook.vue?vue&type=script&lang=js"
export * from "./upLook.vue?vue&type=script&lang=js"
import style0 from "./upLook.vue?vue&type=style&index=0&id=1b405c5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b405c5a",
  null
  
)

export default component.exports